import { IonContent, IonPage, IonCol, IonRow, IonGrid, IonList, IonLabel, IonItem, IonSelect, IonSelectOption, IonInput, IonTextarea, IonCard, IonCardHeader, IonFooter, IonIcon, IonTitle, useIonViewDidEnter, IonToast } from '@ionic/react';
import React, { useContext, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipCreatePostPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import PostTitleOptions, { AllPostTitleOptions, PostTitleOptionsQuestions, PostTitleOptionsValues } from '../../data/PostTitleOptions';
import { bookSharp, chatbubble, chatbubblesSharp, send } from 'ionicons/icons';
import { useDispatch, useSelector } from 'react-redux';
import { SelectActiveGroupId, SelectGroup, SelectGroups, UpdateActiveGroupId } from '../../store/FellowshipSlice';
import IFellowshipPost from '../../interfaces/IFellowshipPost';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { SelectCurrentUser } from '../../store/UserSlice';
import { useHistory, useParams } from 'react-router-dom';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { ReactComponent as PrayerIcon } from '../../assets/images/prayerLogo.svg';
import PostTypes, { PostTypesValues } from '../../data/PostTypes';
import PrayerService from '../../services/PrayerService';
import IPrayer from '../../interfaces/IPrayer';
import PrayerStatus, { PrayerStatusValues } from '../../data/PrayerStatus';
import { CreatePostObject } from '../../data/CreatePostObjects';
import UnregisterGroup from '../../data/UnregisteredGroup';
import { SelectActiveReadingPlanRecord, SelectActiveSession, SelectSelectedVerse } from '../../store/BibleStudySlice';
import { BibleVersionNames } from '../../data/BibleVersions';
import NetworkNotification from '../../components/NetworkNotification/NetworkNotification';
import PostVideos from '../../components/PostVideos/PostVideos';
import FellowshipGroupSelectorHeader from '../../components/FellowshipGroupSelectorHeader/FellowshipGroupSelectorHeader';
import FellowshipSettingsService from '../../services/FellowshipSettingsService';

const FellowshipCreatePostPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [postTopic, setPostTopic] = useState<PostTitleOptionsValues | ''>('');
  const [customPostTitle, setCustomPostTitle] = useState('');
  const [postTextArea, setPostTextArea] = useState('');
  const [selectedPrayerId, setSelectedPrayerId] = useState('');
  const [selectedPrayer, setSelectedPrayer] = useState<IPrayer | undefined>(undefined)
  const [postPrayerTitle, setPostPrayerTitle] = useState('');
  const [postPrayerDescription, setPostPrayerDescription] = useState('');
  const [showPrayerSelector, setShowPrayerSelector] = useState(true);
  const [postBibleTitle, setPostBibleTitle] = useState('');
  const [postBibleMessage, setPostBibleMessage] = useState('');
  const [postBibleTitleLabel, setPostBibleTitleLabel] = useState('REFERENCE or DAY/QUESTION:')
  const [selectedPostType, setSelectedPostType] = useState<PostTypesValues>(PostTypes.fellowship);
  const [initialLoad, setInitialLoad] = useState(true);
  const [prayerListActive, setPrayerListActive] = useState<(IPrayer | undefined)[]>([]);
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastFailedMessage, setToastFailedMessage] = useState('Failed: Could not submit group post.');
  const dbService = useContext(ServerDBContext);
  const currentUser = useSelector(SelectCurrentUser);
  const currentGroup = useSelector(SelectGroup);
  const activeGroupId = useSelector(SelectActiveGroupId);
  const userGroups = useSelector(SelectGroups);
  const activeSession = useSelector(SelectActiveSession);
  const selectedVerse = useSelector(SelectSelectedVerse);
  const activeReadingPlanRecord = useSelector(SelectActiveReadingPlanRecord);
  const { postType, shareIdentifier } = useParams<{ postType?: string; shareIdentifier?: string; }>();

  useIonViewDidEnter(async() => {
    if( postType && shareIdentifier) {
      const sessionText = (activeReadingPlanRecord && activeReadingPlanRecord.sessionsPerDay > 1) ? 'READING' : 'DAY';

      switch(parseInt(postType)) {
        case PostTypes.prayer :
          setInitialLoad(false);
          const result = await PrayerService.getAllPrayers();
            if(result.Success) {
              const userPrayers = result.Data!;
              const selectedPrayer = userPrayers.find(prayer => prayer.id === parseInt(shareIdentifier));
              if(selectedPrayer) {
                setSelectedPrayer(selectedPrayer);
                setShowPrayerSelector(false);
                setPostPrayerTitle(selectedPrayer.title);
                setPostPrayerDescription(selectedPrayer.description!);
              } else { loadPrayers()}
            }
          setSelectedPostType(PostTypes.prayer);
          setPrayerFormValues(shareIdentifier);
          break;
        case PostTypes.bible :
          setInitialLoad(false);
          setSelectedPostType(PostTypes.bible);
          setPostBibleTitle(`${sessionText} ${shareIdentifier}`);
          setPostBibleTitleLabel('REFERENCE or DAY/QUESTION:');
          break;
        case PostTypes.bibleQuestion :
          setInitialLoad(false);
          setSelectedPostType(PostTypes.bible);
          const postTitle = `${sessionText} ${activeSession.session} - QUESTION ${shareIdentifier}`;
          setPostBibleTitle(postTitle);
          setPostBibleMessage(activeSession?.questions![+shareIdentifier - 1]);
          setPostBibleTitleLabel(`${sessionText}/QUESTION #:`);
          break;
        case PostTypes.bibleVerse :
          if(selectedVerse) {
            setInitialLoad(false);
            setSelectedPostType(PostTypes.bible);
            setPostBibleTitle(`${selectedVerse?.displayReference}`);
            setPostBibleMessage(`${selectedVerse?.text} (${selectedVerse?.displayReference} ${BibleVersionNames[selectedVerse.version]})`);
            setPostBibleTitleLabel('BIBLE VERSE REFERENCE:');
          }
          break;
      }

    } else {
      setInitialLoad(true);
      setShowPrayerSelector(true);
    }
  }, [postType, shareIdentifier]);

  const updateFellowshipPostTopic = (title: PostTitleOptionsValues | '') => {
    setPostTopic(title);
    if(title !== PostTitleOptions.other) {
      setCustomPostTitle(title);
    } else {
      setCustomPostTitle('');
    }
    
  }

  const setPrayerFormValues = (prayerId: string | 'new') => {
    setSelectedPrayerId(prayerId);

    if(prayerId === 'new'){
      setPostPrayerTitle('');
      setPostPrayerDescription('');
    } else {  
      const selectedPrayer = prayerListActive.find(prayer => prayer && parseInt(prayerId) === prayer.id);   
      if(selectedPrayer) {
        setSelectedPrayer(selectedPrayer);
        setPostPrayerTitle(selectedPrayer.title);
        setPostPrayerDescription(selectedPrayer.description!);
      }
    }
  }

  const createNewPost = (title: string, postText: string) => {
    // make sure user is in a group before trying to share...
    if(currentGroup && currentGroup.id !== UnregisterGroup.id) {

      if(title && postText) {
        const currentDate = new Date(Date.now());
        const newPost: IFellowshipPost = CreatePostObject( 
        {
          id: currentDate.toDateString(),
          userId: currentUser.id,
          groupId: currentGroup.id,
          type: selectedPostType,
          author: currentUser.displayName ? currentUser.displayName: 'Unknown',
          title,
          postText,
        });
        console.log('Sending Post');
        dbService?.createPost(newPost).then(resultCreated => {
          if(resultCreated.Success) {
              console.log('Post Created');
              setPostTopic('');
              setCustomPostTitle('');
              setPostTextArea('');
              setSelectedPrayerId('');
              setPostBibleMessage('');
              setPostBibleTitle('');
              setInitialLoad(true);
              setShowPrayerSelector(true);
              if(selectedPostType === PostTypes.prayer && selectedPrayerId === 'new') {
                // Add new prayer to my prayers list
                const result = savePrayer(title, postText, PrayerStatus.active, resultCreated.Data as string);
                console.log('Saved New Prayer:', result);
              } else if (selectedPostType === PostTypes.prayer && selectedPrayer) {
                // Update prayer to have the post id which was shared with the group
                const updatedPrayer: IPrayer = {...selectedPrayer, linkedPostId: resultCreated.Data as string };
                PrayerService.updatePrayer(updatedPrayer).then(() => {
                  console.log("Updated Prayer Result:", updatedPrayer);
                }).catch ((err:Error) => {
                  console.error(err);
                })                
              }
              history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, { direction: 'back' })
          } else {
              console.log('Post Failed');
              setToastFailedMessage(resultCreated.Message.UserMessage);
              setDisplayToastFailed(true);
          };
        });
      } else {
        setToastFailedMessage('PLEASE COMPLETE THE FORM BEFORE SHARING WITH GROUP');
        setDisplayToastFailed(true);
      }
    } else {
      setToastFailedMessage('YOU MUSH JOIN A GROUP OR CREATE A GROUP TO SHARE POSTS');
      setDisplayToastFailed(true);
    }
  }
  
  const loadPrayers = async () => {
    const result = await PrayerService.getAllPrayers();
    if(result.Success) {
      const userPrayers = result.Data!;
      setPrayerListActive(userPrayers.filter(prayer => prayer?.status === PrayerStatus.active));
    }
  }

  const savePrayer = async (title: string, description: string, status: PrayerStatusValues, linkedPostId: string) => {
    const today = new Date(Date.now());  
    const currentPrayer: IPrayer = {
      id: 0,
      title,
      description,
      status,
      modifiedDate: today,
      createdDate: today,
      order: Date.now(),
      linkedPostId,
    };
    return await PrayerService.createPrayer(currentPrayer);
  }

  const setActiveGroup = (groupId: string) => {
    dispatch(UpdateActiveGroupId(groupId));
    FellowshipSettingsService.getFellowshipSettings().then(result => {
      if(result.Success) {
        const settingToUpdate =  result.Data!;
        settingToUpdate.defaultGroupId = groupId;
        FellowshipSettingsService.updateFellowshipSettings(settingToUpdate);
      }
    });
  }

  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} ></PageHeader>
      <FellowshipGroupSelectorHeader 
         {...props}
         className={'reveal'}
         userGroups={userGroups}
         activeGroupId={activeGroupId}
         setActiveGroup={setActiveGroup}
         disableGroupSelector={true}></FellowshipGroupSelectorHeader>
      <IonContent fullscreen={true} >
        <div className="fellowship-create-post-header">
          <h3 className="ion-text-center">CREATE A NEW POST</h3>
        </div>
      <IonGrid fixed={true}>
          <IonRow >
            <IonCol className="announcement-text">
              <div className={`post-type-selectors ${selectedPostType === PostTypes.bible || initialLoad ? 'post-type-bible-selected' : 'post-type-bible-deselected'}`}
                onClick={() => {setSelectedPostType(PostTypes.bible); setInitialLoad(false);}}>
                <IonIcon icon={bookSharp} className="selector-icons"></IonIcon>
                <p>BIBLE</p>
              </div>
            </IonCol>
            <IonCol className="announcement-text">
              <div className={`post-type-selectors ${selectedPostType === PostTypes.prayer || initialLoad ? 'post-type-prayer-selected' : 'post-type-prayer-deselected'}`}
                onClick={() => {setSelectedPostType(PostTypes.prayer); loadPrayers(); setInitialLoad(false);}}>
                <PrayerIcon className="color-white selector-icons" />
                <p>PRAYER</p>
              </div>
            </IonCol>
            <IonCol className="announcement-text">
              <div className={`post-type-selectors ${selectedPostType === PostTypes.fellowship || initialLoad ? 'post-type-fellowship-selected' : 'post-type-fellowship-deselected'}`}
                onClick={() => {setSelectedPostType(PostTypes.fellowship); setInitialLoad(false);}}>
                <IonIcon icon={chatbubblesSharp} className="selector-icons"></IonIcon>
                <p>FELLOWSHIP</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol className="announcement-text">
              { !initialLoad && selectedPostType === PostTypes.fellowship ?
              <IonCard>
                <IonCardHeader color="tertiary" mode="md">
                  <IonTitle className="create-post-title">
                    <IonIcon icon={chatbubble}></IonIcon>
                    FELLOWSHIP POST
                  </IonTitle>

                  </IonCardHeader>
                <IonList className="create-post-list">
                  <IonItem>
                    <IonSelect label="POST TOPIC:" labelPlacement="stacked"
                      color="tertiary" value={postTopic} placeholder="SELECT" onIonChange={e => updateFellowshipPostTopic(e.detail.value?.toString())} interface="popover">
                      {AllPostTitleOptions.map(option => (
                        <IonSelectOption key={`$select-topic-${option}`} color="tertiary" value={option} className="post-title-options">{option}</IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>
                  {postTopic === PostTitleOptions.other ?
                    <IonItem>
                      <IonInput label="CUSTOM TOPIC:" labelPlacement="stacked" value={customPostTitle} 
                        onIonChange={e => setCustomPostTitle(e.detail.value?.toString()!)} placeholder="ENTER TOPIC" className="ion-text-right" />
                    </IonItem>
                    : null
                  }
                  {postTopic !== '' ?
                    <IonItem >
                      <IonTextarea color="tertiary" label={PostTitleOptionsQuestions[postTopic]} labelPlacement="stacked" placeholder="Enter Message Here..." autoGrow={true} autoCapitalize='sentences'
                        value={postTextArea} onIonChange={e => setPostTextArea(e.detail.value?.toString()!)} ></IonTextarea>
                    </IonItem> : <p>SELECT A TOPIC TO GET STARTED</p>
                  }
                </IonList>
                { postTextArea !== '' ?
                      <PostVideos key='fellowshipPostVideoPreview' delay={2500} postText={postTextArea}></PostVideos> : ''
                  }
                <IonFooter mode="md">
                  <IonItem mode="ios" color="tertiary" onClick={() => createNewPost(customPostTitle, postTextArea)}>
                    <IonLabel>SHARE WITH GROUP</IonLabel>
                    <IonIcon slot="end" icon={send} className="cursor-pointer"></IonIcon>
                  </IonItem>
                </IonFooter>
              </IonCard> 
              
              :  !initialLoad && selectedPostType === PostTypes.prayer ?
              <IonCard>
                <IonCardHeader color="secondary" mode="md">
                  <IonTitle className="create-post-title">
                  <PrayerIcon className="color-white post-prayer-header-icon" />
                    PRAYER POST
                  </IonTitle>

                </IonCardHeader>
                <IonList className="create-prayer-post-list">
                  {showPrayerSelector &&
                    <IonItem>
                      <IonSelect label="SELECT PRAYER:" 
                      color="secondary" value={selectedPrayerId} placeholder="SELECT" onIonChange={e => setPrayerFormValues(e.detail.value?.toString())} interface="popover">
                      <IonSelectOption key="select-topic-new-prayer" color="secondary" value="new" className="post-prayer-title-options">NEW PRAYER</IonSelectOption>
                        {prayerListActive.map(prayer => (prayer &&
                          <IonSelectOption key={`$select-topic-${prayer.id}`} color="secondary" value={prayer.id} className="post-prayer-title-options">{prayer.title}</IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>

                  }
                  { selectedPrayerId === 'new' && 
                    <p className="create-new-prayer-post-notice">
                      <b>NOTICE:</b><br />
                       New prayers are automatically added to you active prayers on this device.
                    </p>
                }
                  {selectedPrayerId ?
                    <div>
                      <IonItem>
                        <IonInput label="PRAYER TITLE:" labelPlacement="stacked" 
                          color="medium" value={postPrayerTitle} onIonChange={e => setPostPrayerTitle(e.detail.value?.toString()!)} placeholder="ENTER TITLE" />
                      </IonItem>
                      <IonItem >
                        <IonTextarea label="PRAYER DESCRIPTION:" labelPlacement="stacked" color="medium" placeholder="ENTER PRAYER DESCRIPTION" autoGrow={true} autoCapitalize='sentences'
                          value={postPrayerDescription} onIonChange={e => setPostPrayerDescription(e.detail.value?.toString()!)} ></IonTextarea>
                      </IonItem>
                    </div> : <p>SELECT A PRAYER TO GET STARTED</p>
                  }
                </IonList>
                <IonFooter mode="md">
                  <IonItem mode="ios" color="secondary" onClick={() => createNewPost(postPrayerTitle, postPrayerDescription)}>
                    <IonLabel>SHARE WITH GROUP</IonLabel>
                    <IonIcon slot="end" icon={send} className="cursor-pointer"></IonIcon>
                  </IonItem>
                </IonFooter>
              </IonCard> 

              :   !initialLoad && (
                    selectedPostType === PostTypes.bible || 
                    selectedPostType === PostTypes.bibleQuestion ||
                    selectedPostType === PostTypes.bibleVerse
                  ) ?
              <IonCard>
                <IonCardHeader color="primary" mode="md">
                  <IonTitle className="create-post-title">
                    <IonIcon icon={bookSharp}></IonIcon>
                    BIBLE POST
                  </IonTitle>

                </IonCardHeader>
                <IonList className="create-bible-post-list">
                  <IonItem>
                    
                    <IonInput label={postBibleTitleLabel} labelPlacement={'stacked'} color="primary"
                      value={postBibleTitle} onIonChange={e => setPostBibleTitle(e.detail.value?.toString()!)} 
                      autoCapitalize='sentences' placeholder="EX: John 3:16 or Day 234 - Question 2" />
                  </IonItem>
                  <IonItem>
                    <IonTextarea label="MESSAGE" labelPlacement="stacked" color="medium" placeholder="ENTER MESSAGE" autoGrow={true} autoCapitalize='sentences'
                      value={postBibleMessage} onIonChange={e => setPostBibleMessage(e.detail.value?.toString()!)} ></IonTextarea>
                  </IonItem>
                </IonList>
                <PostVideos key='biblePostVideoPreview' delay={2500} postText={postBibleMessage}></PostVideos>
                <IonFooter mode="md">
                  <IonItem mode="ios" color="primary" onClick={() => createNewPost(postBibleTitle, postBibleMessage)}>
                    <IonLabel>SHARE WITH GROUP</IonLabel>
                    <IonIcon slot="end" icon={send} className="cursor-pointer"></IonIcon>
                  </IonItem>
                </IonFooter>
              </IonCard> 
              : <div className="fellowship-create-post-header">
                  <p className="ion-text-center">...select post type...</p>
                </div>
            }
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message={toastFailedMessage}
          duration={3000} />
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to post to your group."></NetworkNotification>
      </IonContent>
    </IonPage>
  );
};

export default FellowshipCreatePostPage;